import SettingsSettingsPartContainer from "@baseUI/component/settings/SettingsSettingsPartContainer";

export default class SettingsSettingsPartContainerPortrait extends SettingsSettingsPartContainer {

    constructor(params) {
        super(params)
        this.spaceText.visible = false
        this.spaceState.visible = false
    }

    setParametersSizePosition(params){
        this.param = {
            panelPopupPosition: {x: 0, y: 0},
            popupSettingsCaptionPosition: params.captionPosition,
            lineTop: {x1: 30, y1: 100, x2: 930, y2: 100 },
            lineMiddle: {x1: 30, y1: 500, x2: 930, y2: 500 },
            musicTextPosition: [150, 210],
            soundsTextPosition: [150, 360],
            spaceTextPosition: [150, 650],
            musicStatePosition: [800, 240],
            soundsStatePosition: [800, 390],
            spaceStatePosition: [800, 680]
        }
    }
}